@let _event = event();

<div
  [ngClass]="
    (_event.id | in: service.selectedEventIds()) && eventType() === 'PLAN'
      ? '!border-2 border-primary rounded-lg'
      : (_event.id | in: service.selectedEventIds()) && eventType() === 'absence'
        ? '!border-2 border-warning rounded-lg'
        : ''
  "
>
  <soft-pms-task-drag-card
    [headText]="_event.id + ''"
    [headTextColor]="'text-primary'"
    [bgColor]="eventType() === 'PLAN' ? 'bg-primary' : 'bg-warning'"
    [title]="_event.title ?? ''"
    [description]="$safeNavigationMigration(_event?.start) + ' - ' + $safeNavigationMigration(_event?.end)"
  ></soft-pms-task-drag-card>
</div>
